import getContainsIgnoredAttributes from "./getContainsIgnoredAttributes"

const checkPerformanceFilterIsSet = (technologyAttributes, filterType, filterValue, queryStringValues) => {
    const containsIgnoredAttributes = getContainsIgnoredAttributes(technologyAttributes)
    if(filterType && filterType === 'technical' && filterValue !== 'Vorschau') {
        return true
    } else if(queryStringValues && (queryStringValues.theatreName || queryStringValues.seatClasses || (queryStringValues.technical && !containsIgnoredAttributes))) {
        return true
    } else {
        return false
    }
}

export default checkPerformanceFilterIsSet